export const FETCH_REVIEWS = 'FETCH_REVIEWS'
export const TOTAL_REVIEWS_COUNT = 'TOTAL_REVIEWS_COUNT'
export const FETCH_REVIEWS_BEGIN = 'FETCH_REVIEWS_BEGIN'
export const FETCH_REVIEWS_END = 'FETCH_REVIEWS_END'
export const UPDATE_BEGIN = 'UPDATE_BEGIN'
export const UPDATE_END = 'UPDATE_END'
export const UPDATE_SINGLE_REVIEW = 'UPDATE_SINGLE_REVIEW'
export const ADD_SINGLE_REVIEW = 'ADD_SINGLE_REVIEW'